import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Config } from "../models/config";
import { AppHttpClient } from './http.client';

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  constructor(private http: AppHttpClient) { }

  getAll(): Observable<Config[]> {
    return this.http.get<Config[]>(`config`);
  }

  put(data: Config): Observable<any> {
    return this.http.put<any>(`config`, data);
  }
}
